









































import {Component, Prop} from 'vue-property-decorator';
import Form from '@/layouts/Form';

import InputDefault from '@/components/input/Input.vue';

import InputFile from '@/components/input/InputFile.vue';
import SelectCustom from '@/components/select/SelectCustom.vue';
import ImageInput from "@/components/image-input/ImageInput.vue";

import {getDictionaries} from "@/api/dictionaries";
import {deleteImage} from "@/api/storage";

import SymptomsEntityModule from '@/store/symptoms/entity';

const all = {id: 'all', value: 'Любой'}
type iconPreview = 'defaultIconPreview' | 'activeIconPreview'

@Component({
    components: {
        ImageInput,
        SelectCustom,
        InputFile,
        InputDefault,
    },
})
export default class SymptomsForm extends Form {
    @Prop({}) formValues?: any;
    @Prop({ type: Object, default: () => ({}) }) errors!: Record<string, string>;

    values: any = {
        title: '',
        type: null,
        defaultIcon: null,
        activeIcon: null,
    }

    listType = [all]

    defaultIconPreview = '';
    activeIconPreview = '';

    get model() {
        return SymptomsEntityModule.model;
    }

    returnBefore() {
        this.$router.push({name: 'symptoms'});
    }

    initFormValues() {
        if (!this.formValues) {
            return;
        }

        const {
            title = '',
            type: initialType,
            defaultIcon: initialDefaultIcon,
            activeIcon: initialActiveIcon,
        } = this.formValues;

        const type: any = this.listType.find(el => el.id === initialType)

        const defaultIconSrc = initialDefaultIcon?.src;
        const activeIconSrc = initialActiveIcon?.src;

        this.values = {
            title,
            type,
            defaultIcon: defaultIconSrc ?? null,
            activeIcon: activeIconSrc ?? null
        }

        this.defaultIconPreview = defaultIconSrc ?? '';
        this.activeIconPreview = activeIconSrc ?? '';
    }

    loadImage (icon: 'defaultIcon' | 'activeIcon', file: File) {
        if (this.values[icon]) {
            this.removePreview(icon);
        }

        this.values[icon] = file;

        this[`${icon}Preview` as iconPreview] = URL.createObjectURL(file);
    }

    removePreview (icon: 'defaultIcon' | 'activeIcon',) {
        this.values[icon] = null;

        URL.revokeObjectURL(this[`${icon}Preview` as iconPreview]);
        this[`${icon}Preview` as iconPreview] = '';
    }

    async createNew() {
        return this.update();
    }

    async update() {
        const { defaultIcon, activeIcon } = this.values;

        // if user removed the old photo or selected a new photo, then delete the old one
        const oldDefaultIcon = this.formValues?.defaultIcon;
        const shouldDeleteOldDefaultIcon = defaultIcon === null || defaultIcon instanceof File;

        if (oldDefaultIcon && shouldDeleteOldDefaultIcon) {
            try {
                await deleteImage(oldDefaultIcon.id);
            } catch (error) {
                console.log('The default icon is not found')
            }
        }
        const oldActiveIcon = this.formValues?.activeIcon;
        const shouldDeleteOldActiveIcon = activeIcon === null || activeIcon instanceof File;

        if (oldActiveIcon && shouldDeleteOldActiveIcon) {
            try {
                await deleteImage(oldActiveIcon.id);
            } catch (error) {
                console.log('The active icon is not found')
            }
        }
        const data = this.prepareData();

        this.$emit('submit', data);
    }

    prepareData() {
        const {
            title,
            type,
            defaultIcon,
            activeIcon
        } = this.values;


        const typeId = type?.id ?? '';

        const request: any =  {
            title,
        };

        if (typeId) {
            request.type = typeId
        }

        if (defaultIcon instanceof File) {
            request.defaultIcon = defaultIcon;
        }

        if (activeIcon instanceof File) {
            request.activeIcon = activeIcon;
        }

        return request;
    }

    async mounted() {
        const dictionaries = await getDictionaries()
        const types = Object.keys(dictionaries.patientTypes).filter(key => key).map((key: string) => {
            return {
                id: key,
                value: dictionaries.patientTypes[key]
            }
        })
        this.listType = this.listType.concat(types)
        this.initFormValues();
    }

    beforeDestroy() {
        this.removePreview('activeIcon');
        this.removePreview('defaultIcon');
    }
}
